module.exports = __webpack_public_path__ + "static/media/balls_banner.b42654aa.png";